export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/36f20bd109d924711a6d7e732ddd1416.jpg"
          alt="Professional workspace"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1A2B4C]/50 via-[#1A2B4C]/40 to-[#1A2B4C]/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 sm:px-6 py-16 sm:py-20 text-center">
        <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-7xl font-['Playfair_Display'] font-bold text-white mb-6 sm:mb-8 leading-tight">
          Превратите ваш бизнес<span className="hidden sm:inline"><br /></span>{' '}в систему генерации прибыли
        </h1>
        
        <p className="text-lg sm:text-2xl md:text-3xl text-white/95 mb-4 sm:mb-6 font-medium font-['Montserrat']">
          Разработка сайта-стратегии за 7 дней
        </p>
        
        <p className="text-sm sm:text-lg md:text-xl text-white/90 mb-8 sm:mb-12 max-w-4xl mx-auto leading-relaxed font-['Montserrat']">
          Получите не просто сайт, а готовую маркетинговую архитектуру со встроенным SEO,{' '}
          <span className="hidden sm:inline"><br /></span>
          которая продает вашу <span className="font-bold text-[#C5A880] bg-[#C5A880]/20 px-2 sm:px-3 py-1 rounded-lg">экспертность</span> или <span className="font-bold text-[#C5A880] bg-[#C5A880]/20 px-2 sm:px-3 py-1 rounded-lg">товар</span> 24/7
        </p>

        <div className="inline-block bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl px-4 sm:px-8 py-4 sm:py-6 mb-8 sm:mb-12">
          <p className="text-sm sm:text-lg md:text-xl text-white font-medium font-['Montserrat']">
            Пока другие рисуют картинки, мы проектируем путь вашего клиента
            <span className="hidden sm:inline"><br /></span>
            {' '}от первого клика до оплаты
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center px-2">
          <a
            href="#lead-form"
            className="group w-full sm:w-auto bg-[#C5A880] hover:bg-[#B39770] text-white px-6 sm:px-10 py-4 sm:py-5 rounded-full text-sm sm:text-lg font-semibold transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer font-['Montserrat'] text-center"
          >
            Заказать разработку сайта
            <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform inline-block"></i>
          </a>
          <a
            href="#specialization"
            className="group w-full sm:w-auto bg-white/20 backdrop-blur-md hover:bg-white/30 text-white border-2 border-white/40 px-6 sm:px-10 py-4 sm:py-5 rounded-full text-sm sm:text-lg font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer font-['Montserrat'] text-center"
          >
            Узнать подробнее
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}